import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import colors from '../../../../../styles/colors';

const useStyles = makeStyles({
  root: {
    padding: '1.2rem',
    border: `1px solid ${colors.assignment.grey}`
  },
  title: {
    marginBottom: '.5rem'
  },
  list: {
    margin: 0,
    padding: 0,
    paddingLeft: '12px'
  },
  text: {
    color: colors.assignment.lightgrey
  }
});

const AssignmentTips: React.FC<any> = () => {
  const classes = useStyles();
  return (
    <Paper elevation={0} className={classes.root}>
      <Grid container>
        <Grid item className={classes.title} xs={12}>
          <h3>Assignment Quality Tips</h3>
        </Grid>
        <Grid item xs={12}>
          <ul className={classes.list}>
            <li className={classes.text}>
              Have at least 5 questions to ensure the quality of the assignment
            </li>
          </ul>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AssignmentTips;
